import { ICorporatePartner } from './corporate-partner.interface';

export class PersonalPartner implements ICorporatePartner {
  public name = 'personal';
  public displayBusinessLogo = false;
  public updateBgColor = false;
  public restrictPaxToOne = false;
  public disableMiles = false;
  public displayInlineText = 'personal';
  public showPopupForEcert = false;
  public showBusinessText = false;
  public showBusinessMilesLabel = false;
}
